import React, { useEffect, useRef, useState } from 'react';
import { menuData } from '../data/menu';
import { MenuCategoryBlock } from './MenuCategoryBlock';
import { TricolorStripe } from './TricolorStripe';
export function MenuSection() {
  const [active, setActive] = useState(menuData[0].id);
  const tabRefs = useRef<Record<string, HTMLAnchorElement | null>>({});
  useEffect(() => {
    const observer = new IntersectionObserver(entries => {
      const visible = entries.filter(e => e.isIntersecting).sort((a, b) => a.boundingClientRect.top - b.boundingClientRect.top);
      if (visible[0]) setActive(visible[0].target.id);
    }, {
      rootMargin: '-140px 0px -55% 0px'
    });
    menuData.forEach(c => {
      const el = document.getElementById(c.id);
      if (el) observer.observe(el);
    });
    return () => observer.disconnect();
  }, []);
  useEffect(() => {
    tabRefs.current[active]?.scrollIntoView({
      block: 'nearest',
      inline: 'center',
      behavior: 'smooth'
    });
  }, [active]);
  return <section id="menu" aria-labelledby="menu-heading" className="w-full bg-paper" data-id="element-23" data-mp="3ql8abbkdjk4q">
      <div className="mx-auto max-w-6xl px-4 pt-14 sm:px-6" data-id="element-24" data-mp="3vkku1nfy8b33">
        <div className="flex flex-col gap-2 sm:flex-row sm:items-end sm:justify-between" data-id="element-25" data-mp="3vj00a01gkw6a">
          <h2 id="menu-heading" className="font-display text-5xl text-salsa sm:text-6xl" data-id="element-26" data-mp="48rrsfj8gsaw">
            Menú
          </h2>
          <p className="text-sm text-muted" data-id="element-27" data-mp="37nf7sadnxc7v">Call it in — we'll have it hot at the window.</p>
        </div>
        <div className="mt-4" data-id="element-28" data-mp="3cm8gzqlx2h28">
          <TricolorStripe className="h-1 max-w-[120px] rounded-full overflow-hidden" data-id="element-29" data-mp="3cnjpg3qb4czo" />
        </div>
      </div>

      <nav aria-label="Menu categories" className="sticky top-16 z-40 mt-6 border-y border-line bg-paper/95 backdrop-blur" data-id="element-30" data-mp="3hk0auq64gd92">
        <ul className="no-scrollbar mx-auto flex max-w-6xl gap-2 overflow-x-auto px-4 py-3 sm:px-6" data-id="element-31" data-mp="wvmbvbc51pnu">
          {menuData.map(c => {
          const isActive = active === c.id;
          return <li key={c.id} className="shrink-0" data-id="element-32" data-mp="2xxbslvcyp57j">
                <a ref={el => {
              tabRefs.current[c.id] = el;
            }} href={`#${c.id}`} aria-current={isActive ? 'true' : undefined} className={`inline-block whitespace-nowrap rounded-full px-4 py-2 text-sm font-semibold transition-colors duration-150 ease-out focus:outline-none focus-visible:ring-2 focus-visible:ring-salsa ${isActive ? 'bg-verde text-white' : 'text-ink hover:bg-cream'}`} data-id="element-33" data-mp="2xvqwi1b01e7k">
                  {c.title}
                </a>
              </li>;
        })}
        </ul>
      </nav>

      <div className="mx-auto flex max-w-6xl flex-col gap-16 px-4 py-12 sm:px-6" data-id="element-34" data-mp="2j8fouahxuecq">
        {menuData.map(c => <MenuCategoryBlock key={c.id} category={c} data-id="element-35" data-mp="1vhs9x59luogo" />)}
      </div>
    </section>;
}